
<template>
	<div class="main" style="width:1440px;margin: 0 auto; ">
		<div class="banner_box">
			<img src="/banner02.jpg" alt="" width="1440px" height="300px">
		</div>
		
		<div class="container">
			<div class="title">公司介绍</div>
			<div class="text1">
				{{companyIntroduction.description}}
			</div>
			<div class="pic" style='width: 100%; display: flex;justify-content: space-between;'>
				<template v-for="item in imgList"> 
					<img v-if="item" :src="imgurl+item" alt="" srcset="" width="580" height="350">
				</template>
				
			</div>
		</div>
		<div class="container">
			<div class="title1">发展历程</div>
			<div class="about-main2">
				<div class="licheng-bg">
					<img src="../static/lc-quxian.png" class="quxian" />
					<div class="warper pr">
						<!-- <div class="ny-title">
							<h3 class="title-en">DEVELOPMENT</h3>
							<h4 class="title-ch">发展历程</h4>	
							<i></i>
						</div> -->
						<div class="licheng-content swiper-container">
							<!-- <div class="swiper-wrapper"> -->
								<!-- <div class="swiper-slide"> -->
									<ul class="ul1">
										<template v-for="(item,index) in timeLineList">
											<li :class="`item${index+1}`">
												<a class="clearfix">
													<div class="lc-left">
														 <span v-if="index%2!==0" class="date">{{item.title}}</span><i class="line"></i> <span v-if="index%2==0" class="date">{{item.title}}</span>
													</div>
													<div class="lc-right">
														<div class="right-text">
															<h3></h3>
															<p>{{item.description}}</p>
															<!-- <p>1995年12月14日，某某某有限公司成立。</p> -->
														</div>
													</div>
												</a>
											</li>
										</template> 
										
									</ul>
								<!-- </div> -->
								
							<!-- </div> -->
							<!-- <div class="lc-swiper-btn">
								<a class="btn-prev fl"><i class="iconfont">&#xe624;</i></a>
								<a class="btn-next fr"><i class="iconfont">&#xe626;</i></a>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container1">
			<div class="title1">品牌理念</div>
			<div class="text1">
				{{brandConcept.description}}
			</div>
			<div class="pic1" style='width: 100%; display: flex;justify-content: space-between;'>
				<template v-for="item in imgList2"> 
					<img :src="imgurl+item" alt="" srcset="" width="380" height="230">
				</template>
			</div>
		</div>
		
		
		<div class="container2">
			<div class="container2_left">
				<div class="title2">经营理念</div>
				<div class="text2">
					{{managementIdea.description}}
				</div>
			</div>
			<img :src="imgurl+imgList3[0]" alt="" srcset="" width="580" height="350">
		</div>
		
	</div>
</template>

<script>
	import "../static/js/swiper.min.js"
	import "../static/js/jquery-1.11.0.min.js"	
	import Vue from 'vue';
	import {
		imgurl,getAction,putformAction
	} from "@/api/manage";
	
	export default {
		name: 'HelloWorld4',
		props: {
			msg: String
		},
		data() {
			return {
				imgurl: imgurl,
				companyIntroduction:{},
				imgList:[],
				brandConcept:{},
				imgList2:[],
				managementIdea:{},
				imgList3:[],
				timeLineList: []
			}
		},
		mounted(e) {
			this.getCompanyIntroductionList()
			this.getBrandConceptList()
			this.getManagementIdeaList()
			this.getHistory()
		},
		watch: {

		},
		
		methods: {
			getHistory() {
				let that = this;
				let param = {};
				getAction("viwo/developmentHistory/getShowList", param).then(res => {
					if (res.success && res.result) {
						if(res.result.length>8) {
						that.timeLineList =	res.result.slice(0, 8);
						}else {
							that.timeLineList = res.result
						}
						
					}
				})
			},

			getCompanyIntroductionList() {
				let that = this;
				let param = {
					type:'公司介绍'
				};
				getAction("viwo/aboutUs/getList", param).then(res => {
					if (res.success && res.result) {
						that.companyIntroduction = res.result.records[0];
						that.imgList = that.companyIntroduction.img.split(',')
						console.log("公司信息res===",res)
					}
				})
			},
			getBrandConceptList() {
				let that = this;
				let param = {
					type:'品牌理念'
				};
				getAction("viwo/aboutUs/getList", param).then(res => {
					if (res.success && res.result) {
						that.brandConcept = res.result.records[0];
						that.imgList2 = that.brandConcept.img.split(',')
						console.log("公司信息res===",res)
					}
				})
			},
			getManagementIdeaList() {
				let that = this;
				let param = {
					type:'经营理念'
				};
				getAction("viwo/aboutUs/getList", param).then(res => {
					if (res.success && res.result) {
						that.managementIdea = res.result.records[0];
						that.imgList3 = that.managementIdea.img.split(',')
						console.log("公司信息res===",res)
					}
				})
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	@import "../static/css/style.css";
	@import "../static/css/swiper.min.css";
	// @import "../static/css/font/iconfont.css";
	
	.main {
		width:1440px;
		margin: 0 auto; 
		// min-height: 1426px;
	}
	a {
		text-decoration: none;
	}

	.container {
		width: 1200px;
		margin: 110px auto 90px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	
	.title {
		margin: 0 auto;
		width: 144px;
		height: 54px;
		line-height: 54px;
		color: rgb(16,16,16);
		font-size: 36px;
		text-align: center;
		font-family: SourceHanSansSC-regular;
	}
	.text {
		margin: 30px 0;
		width: 1200px;
		height: 81px;
		line-height: 27px;
		color: rgba(174,174,174,1);
		font-size: 18px;
		text-align: center;
		font-family: SourceHanSansSC-regular;
		text-indent: 2em;
	}
	.container1 {
		width: 1440px;
		padding: 90px 120px;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		background-color: #F2F2F2;
	}
	.title1 {
		width: 112px;
		height: 41px;
		line-height: 41px;
		color: rgb(16,16,16);
		font-size: 28px;
		text-align: left;
		font-family: SourceHanSansSC-regular;
	}
	.text1 {
		width: 1200px;
		height: 86px;
		line-height: 24px;
		color: rgba(174,174,174,1);
		font-size: 18px;
		text-align: left;
		font-family: SourceHanSansSC-regular;
		margin: 30px 0;
		text-indent: 2em;
	}
	.container2 {
		display: flex;
		width: 1440px;
		padding: 90px 120px;
		box-sizing: border-box;	
	}
	.container2_left {
		margin-right: 46px;
	}
	
	.title2 {
		width: 112px;
		height: 41px;
		line-height: 41px;
		color: rgb(16,16,16);
		font-size: 28px;
		text-align: left;
		font-family: SourceHanSansSC-regular;
	}
	.text2 {
		margin-top: 30px;
		width: 580px;
		height: 167px;
		line-height: 24	px;
		color: rgb(174,174,174);
		font-size: 18px;
		text-align: left;
		font-family: SourceHanSansSC-regular;
		text-indent: 2em;
	}




.my_timeline_prev, .my_timeline_next {
    float: left;
    display: inline-block;
    background-color: #fff;
    cursor: pointer;
}
.my_timeline_prev {
    width: 200px;
    float: left;
}
.my_timeline_next {
    width: 34px;
    margin-left: -22px;
}
.ul_box {
    width: 900px;
    height: 60px;
    display: inline-block;
    float: left;
    margin-top: 2px;
    overflow: hidden;
}
.my_timeline_item {
    display: inline-block;
    width: 220px;
}
.my_timeline_node {
    box-sizing: border-box;
    border-radius: 50%;
    cursor: pointer;
}
.my_timeline_node.active {
    background-color: #fff !important;
    border: 6px solid #f68720;
}
.my_timeline_item_line {
    width: 100%;
    height: 10px;
    margin: -14px 0 0 28px;
    border-top: 2px solid #E4E7ED;
    border-left: none;
}
.my_timeline_item_content {
    margin: 10px 0 0 -10px;
}
</style>